import { render, staticRenderFns } from "./GenericCrudItem.vue?vue&type=template&id=3290fede&scoped=true&"
import script from "./GenericCrudItem.vue?vue&type=script&lang=js&"
export * from "./GenericCrudItem.vue?vue&type=script&lang=js&"
import style0 from "./GenericCrudItem.vue?vue&type=style&index=0&id=3290fede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3290fede",
  null
  
)

export default component.exports